module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Sandbox")])]), _vm._v(" "), _c('h4', [_vm._v("Analysis Verdicts")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.verdictsSorted), function(verdict, index) {
    return _c('tr', {
      staticClass: "accordion-toggle",
      class: _vm.tableRowStyle(verdict.classification),
      attrs: {
        "data-toggle": "collapse",
        "data-target": '#details' + index
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.epochDate(verdict.timestamp)))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'SandboxRecord',
          params: {
            sha1: verdict.sha1Checksum,
            size: verdict.size
          }
        }
      }
    }, [_vm._v(_vm._s(verdict.sha1Checksum))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.processingState))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.classification))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": _vm.graywareDownloadLink(verdict.sha1Checksum, verdict.size),
        "download": _vm.graywareDownloadFilename(verdict.sha1Checksum, verdict.size)
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("SHA1 Checksum")]), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("Processing State")]), _vm._v(" "), _c('th', [_vm._v("Classification")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59e45290!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sandbox.vue
// module id = 502
// module chunks = 2